export const FORM_TYPE_CREATE_DATA_SOURCE = 'FORM_TYPE_CREATE_DATA_SOURCE';
export const FORM_TYPE_EDIT_DATA_SOURCE = 'FORM_TYPE_EDIT_DATA_SOURCE';
export const FORM_TYPE_CREATE_DATASET = 'FORM_TYPE_CREATE_DATASET';
export const FORM_TYPE_EDIT_DATASET = 'FORM_TYPE_EDIT_DATASET';
export const FORM_TYPE_EDIT_DESTINATION = 'FORM_TYPE_EDIT_DESTINATION';
export const FORM_TYPE_EDIT_DATA_MAP = 'FORM_TYPE_EDIT_DATA_MAP';
export const FORM_TYPE_EDIT_CREDENTIAL = 'FORM_TYPE_EDIT_CREDENTIAL';
export const FORM_TYPE_CREATE_REUSABLE_TX = 'FORM_TYPE_CREATE_REUSABLE_TX';
export const FORM_TYPE_CREATE_SCHEMA_SPEC = 'FORM_TYPE_CREATE_SCHEMA_SPEC';
export const FORM_TYPE_EDIT_QUARANTINE = 'FORM_TYPE_EDIT_QUARANTINE';
export const FORM_TYPE_CREATE_CDC = 'FORM_TYPE_CREATE_CDC';
export const FORM_TYPE_CREATE_ELT = 'FORM_TYPE_CREATE_ELT';
export const FORM_TYPE_CREATE_REPLICATION = 'FORM_TYPE_CREATE_REPLICATION';
export const FORM_TYPE_CREATE_SPARK = 'FORM_TYPE_CREATE_SPARK';
export const FORM_TYPE_CREATE_DIRECT_FLOW = 'FORM_TYPE_CREATE_DIRECT_FLOW';
export const FORM_TYPE_CREATE_LLM_FLOW = 'FORM_TYPE_CREATE_LLM_FLOW';
export const FORM_TYPE_CREATE_RERANKER_FLOW = 'FORM_TYPE_CREATE_RERANKER_FLOW';
